module.exports = __webpack_public_path__ + "img/header-award-logo.28baa6cd.svg";